export { NumberOnImageAnswer } from './NumberOnImageAnswer';
export { NumberOnImageQuestion } from './NumberOnImageQuestion';
